export interface RetryStrategy {
	maxAttempts: number
	delayFor?(attempt: number): number
	shouldRetry?(err: unknown): boolean
	onRetryableFailure?(err: unknown, attempt: number): void
	onTerminalFailure?(err: unknown): void
}

export async function withRetry<T>(strategy: RetryStrategy, action: () => Promise<T>): Promise<T> {
	if (strategy.maxAttempts < 1) {
		throw new Error(`withRetry: maxAttempts must be >= 1, got ${strategy.maxAttempts}`)
	}
	let attempt = 0
	while (true) {
		attempt++
		try {
			return await action()
		} catch (err) {
			const shouldRetry = strategy.shouldRetry?.(err) ?? true
			if (!shouldRetry || attempt >= strategy.maxAttempts) {
				if (shouldRetry) strategy.onTerminalFailure?.(err)
				throw err
			}
			strategy.onRetryableFailure?.(err, attempt)
			const ms = strategy.delayFor?.(attempt)
			if (ms) await new Promise<void>(resolve => setTimeout(resolve, ms))
		}
	}
}
